import React, {Component} from "react";
import PopupClose from "../buttons/popup-close";
import {api, apis, msg, rd, route, routes, sendGet, throws} from "../../../vars/rd";
import CategoryBusiness from "../buttons/category.business";
import DaoCategory from "../../../modules/dao/category";
import {connect} from "react-redux";
import {userChange} from "../../../libs/redux/actions/user";
import {preloaderHide, preloaderShow} from "../../../libs/redux/actions/preloader";

class Business extends Component {
    constructor(props) {
        super(props);

        this.callback = props.callback;
        this.callbackLoaded = props.callbackLoaded;
        this.is_popup = props.is_popup;

        this.state = {
            business: (rd.category.business || []),
            data: props.data,
            close: false
        }
    }

    componentDidMount() {
        if(this.callbackLoaded) this.callbackLoaded.call(null, this);
    }

    componentWillUnmount() {
        this.callback = null;
        this.callbackLoaded = null;
        this.is_popup = false;
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * 창닫기
     */
    close() {
        this.setState({ close: true });
    }

    /**
     *
     * @returns {DaoCategory}
     */
    get data() {
        return this.state.data || new DaoCategory();
    }

    /**
     *
     * @returns {DaoCategory[]}
     */
    get business() {
        return this.state.business || [];
    }

    businessClicked(category) {
        this.setState((pstate) => ({
            data: category,
            business: pstate.business.map(
                /**
                 * @param cate {DaoCategory}
                 * @returns {DaoCategory}
                 */
                cate => {
                    cate.selected = category.proid === cate.proid;
                    return cate;
                }
            ),
        }));
    }

    async businessComplete() {
        try {
            /** @type {DaoCategory} */
            const category = this.state.data;
            if (category && category.proid !== rd.user.business) {
                this.dispatch(preloaderShow());
                const url = api(apis.business_setting, {
                    serviceid: rd.user.serviceid,
                    groupid: rd.user.groupid,
                    business: category.code,
                });
                const json = await sendGet(url);
                if (!json || json.result !== "OK") throws(msg().api_fail);
                if (json.status === "OK") {
                    rd.user.business = category.proid;
                    // 전역이벤트 전송
                    this.dispatch(userChange(rd.user));

                    if (!this.is_popup) route(routes.main);
                    else this.close();
                }
                this.dispatch(preloaderHide());
            } else this.close();
        } catch (err) {}
    }

    render() {
        if (this.is_popup) {
            return (
                <div className="popup-mypage">
                    <h2>
                        내 업종 변경
                        <span>업종별 어울리는 채널을 추천해 드려요.</span>
                        <PopupClose close={this.state.close} />
                    </h2>
                    <div className="popup-content">
                        <div className="recommend-type">
                            <div className="list">
                                {
                                    this.business.map((category, index) => {
                                        category.selected = category.proid === this.data.proid;
                                        return (
                                            <CategoryBusiness key={index} is_mypage={false} category={category} selected={false} onChange={this.businessClicked.bind(this)} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="popup-btn-wrap">
                        <button className="btn-m btn-t1" onClick={() => this.close()}>취소</button>
                        <button className="btn-m btn-p1" onClick={() => this.businessComplete()}>저장하기</button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="channel-wrap">
                    <div className="recommend-type">
                        <div className="list">
                            {
                                this.business.map((category, index) => {
                                    category.selected = category.proid === this.data.proid;
                                    return (
                                        <CategoryBusiness key={index} is_mine={false} category={category} selected={false} onChange={this.businessClicked.bind(this)} />
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="btn-wrap">
                        <div className="btn" onClick={() => this.businessComplete()}><span className="btn-l btn-p2">선택완료</span></div>
                    </div>
                </div>
            );
        }
    }
}

export default connect()(Business);


// WEBPACK FOOTER //
// ./src/pages/components/popup/business.jsx